import { render } from "./AboutVue.vue?vue&type=template&id=62a3ad55&scoped=true"
import script from "./AboutVue.vue?vue&type=script&lang=js"
export * from "./AboutVue.vue?vue&type=script&lang=js"

import "./AboutVue.vue?vue&type=style&index=0&id=62a3ad55&scoped=true&lang=css"

import exportComponent from "C:\\hammer\\andolphi-curriculo-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a3ad55"]])

export default __exports__